import { create } from "zustand";
import type {
  PaymentSettings,
  PaymentMode,
  DepositType,
  CancellationWindow,
  RefundPolicy,
} from "../api/payments";

export interface PaymentsSettingsDraft {
  payment_mode: PaymentMode;
  deposit_type: DepositType | null;
  deposit_value_minor_units: number | null;
  deposit_percent_bps: number | null;
  cancellation_policy_enabled: boolean;
  cancellation_window_hours: CancellationWindow | null;
  cancellation_policy_custom_note: string | null;
  deposit_refund_policy: RefundPolicy | null;
}

export interface PaymentsSettingsSlice {
  draft: PaymentsSettingsDraft | null;
  isDirty: boolean;
  fieldErrors: Record<string, string>;
  formError: string | null;
  initDraft: (settings: PaymentSettings) => void;
  updateDraft: (patch: Partial<PaymentsSettingsDraft>) => void;
  setFieldErrors: (errors: Record<string, string>) => void;
  setFormError: (error: string | null) => void;
  resetDraft: () => void;
}

export const usePaymentsSettingsStore = create<PaymentsSettingsSlice>((set) => ({
  draft: null,
  isDirty: false,
  fieldErrors: {},
  formError: null,

  initDraft: (settings) =>
    set({
      draft: {
        payment_mode: settings.payment_mode,
        deposit_type: settings.deposit_type,
        deposit_value_minor_units: settings.deposit_value_minor_units,
        deposit_percent_bps: settings.deposit_percent_bps,
        cancellation_policy_enabled: settings.cancellation_policy_enabled,
        cancellation_window_hours: settings.cancellation_window_hours,
        cancellation_policy_custom_note: settings.cancellation_policy_custom_note,
        deposit_refund_policy: settings.deposit_refund_policy,
      },
      isDirty: false,
      fieldErrors: {},
      formError: null,
    }),

  updateDraft: (patch) =>
    set((state) => ({
      draft: state.draft ? { ...state.draft, ...patch } : state.draft,
      isDirty: true,
    })),

  setFieldErrors: (errors) => set({ fieldErrors: errors }),

  setFormError: (error) => set({ formError: error }),

  resetDraft: () =>
    set({
      draft: null,
      isDirty: false,
      fieldErrors: {},
      formError: null,
    }),
}));
